export const TEST_ID = 'selectPanel';

export const DEBOUNCE_DEFAULT_TIME = 300;
